import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
  ScrollView,
  ActivityIndicator,
  FlatList,
} from "react-native";

import Fonts from "../../../Resources/Fonts";
import Colors from "../../../Resources/Color";
import GlobalStyles from "../../../Resources/Styles";

import { Menu, MenuItem } from "react-native-material-menu";
import { useScreenDimensions, useDevice } from "../../_layout";

import { observer, Observer } from "mobx-react";

import { MaterialIcons } from "@expo/vector-icons";
import { AntDesign } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import Ionicons from "@expo/vector-icons/Ionicons";
import { Octicons } from "@expo/vector-icons";

import { v4 as uuidv4 } from "uuid";
import IconEmptyView from "../../Components/IconEmptyView";

import { useTranslation } from "react-i18next";
import SearchBar from "../../Components/SearchBar";

import { useDebounce } from "use-debounce";

import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import { formatNumber, formatNumber1Dec } from "../../utils/numberUtils";
import Food from "../../Firestore/Food";

const AddCustomFoodView = ({ isVisible, onClose, coach, food }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const cancel = () => {
    onClose();
  };

  const text = food ? "editFood-string" : "createFood-string";

  const [name, setName] = useState(food ? food.name : "");
  const [quantity, setQuantity] = useState(food ? food.quantity : 100);

  const [calories, setCalories] = useState(food ? food.calories : null);
  const [caloriesString, setCaloriesString] = useState(
    food ? formatNumber1Dec(food.calories) : ""
  );
  const [carbs, setCarbs] = useState(food ? food.carbs : null);
  const [carbsString, setCarbsString] = useState(
    food ? formatNumber1Dec(food.carbs) : ""
  );
  const [protein, setProtein] = useState(food ? food.protein : null);
  const [proteinString, setProteinString] = useState(
    food ? formatNumber1Dec(food.protein) : ""
  );
  const [fats, setFats] = useState(food ? food.fats : null);
  const [fatsString, setFatsString] = useState(
    food ? formatNumber1Dec(food.fats) : ""
  );

  const [brand, setBrand] = useState(
    food && food.brand != null ? food.brand : ""
  );
  const [store, setStore] = useState(
    food && food.store != null ? food.store : ""
  );

  const [isNameHovered, setIsNameHovered] = useState(false);
  const [isQuantityHovered, setIsQuantityHovered] = useState(false);

  const [isCaloriesHovered, setIsCaloriesHovered] = useState(false);
  const [isCarbsHovered, setIsCarbsHovered] = useState(false);
  const [isProteinHovered, setIsProteinHovered] = useState(false);
  const [isFatsHovered, setIsFatsHovered] = useState(false);

  const [isBrandHovered, setIsBrandHovered] = useState(false);
  const [isStoreHovered, setIsStoreHovered] = useState(false);

  const handleChangeQuantity = (text) => {
    const parsedNumber = parseInt(text, 10);
    if (!isNaN(parsedNumber) && parsedNumber > 0) {
      setQuantity(parsedNumber);
    } else {
      setQuantity(null);
    }
  };

  const handleChangeCalories = (text) => {
    const formattedText = text.replace(",", ".");

    // Siempre actualizar el string que se muestra
    setCaloriesString(formattedText);

    // Solo actualizar el valor numérico si es un número válido
    const aux = Number(formattedText);
    if (!isNaN(aux) && aux > 0) {
      setCalories(aux);
    } else if (formattedText === "") {
      setCalories(null);
    }
    // Si está escribiendo algo como "123." no actualizar calories pero mantener el string
  };

  const handleChangeCarbs = (text) => {
    const formattedText = text.replace(",", ".");
    setCarbsString(formattedText);
    const aux = Number(formattedText);
    if (!isNaN(aux) && aux > 0) {
      setCarbs(aux);
    } else if (formattedText === "") {
      setCarbs(null);
    }
  };

  const handleChangeProtein = (text) => {
    const formattedText = text.replace(",", ".");
    setProteinString(formattedText);
    const aux = Number(formattedText);
    if (!isNaN(aux) && aux > 0) {
      setProtein(aux);
    } else if (formattedText === "") {
      setProtein(null);
    }
  };

  const handleChangeFats = (text) => {
    const formattedText = text.replace(",", ".");
    setFatsString(formattedText);
    const aux = Number(formattedText);
    if (!isNaN(aux) && aux > 0) {
      setFats(aux);
    } else if (formattedText === "") {
      setFats(null);
    }
  };

  const Buttons = ({ bool }) => {
    const text = bool ? "save-string" : "cancel-string";

    const [isHovered, setIsHovered] = useState(false);

    const canSave =
      name != "" && calories > 0 && carbs > 0 && protein > 0 && fats > 0;

    const Save = () => {
      if (!canSave) return;

      if (!food) {
        const maxOrder = coach.foods.length
          ? Math.max(...coach.foods.map((m) => m.order))
          : -1;
        const newOrder = maxOrder + 1;

        const q = quantity > 0 ? quantity : 100;

        const newFood = new Food(
          uuidv4(),
          name,
          newOrder,
          q,
          calories,
          carbs,
          protein,
          fats,
          undefined,
          brand != "" ? brand : null,
          store != "" ? store : null,
          null,
          null,
          coach
        );

        coach.updateCoachTransactionFoods(newFood.id);
        coach.startOrResetBatchTimer();

        coach.foods.push(newFood);
      } else {
        food.setProperty("name", name);
        food.setProperty("quantity", quantity);

        food.setProperty("calories", calories);
        food.setProperty("carbs", carbs);
        food.setProperty("protein", protein);
        food.setProperty("fats", fats);

        food.setProperty("brand", brand);
        food.setProperty("store", store);

        coach.updateCoachTransactionFoods(food.id);
        coach.startOrResetBatchTimer();
      }
      onClose();
    };

    return bool ? (
      <TouchableOpacity
        onPress={Save}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: Colors.bubbleColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: Colors.bubbleColor,
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
            // opacity: isHovered ? 0.8 : 1,
            opacity: !canSave ? 0.5 : isHovered ? 0.7 : 1,
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: Colors.whiteColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    ) : (
      <TouchableOpacity
        onPress={cancel}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            // marginHorizontal: 20,
            backgroundColor: isHovered ? Colors.redColor : Colors.whiteColor,
            borderRadius: 14,
            borderWidth: 1,
            justifyContent: "center",
            borderColor: "red",
            width: 80,
            height: 35,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: isHovered ? "white" : Colors.redColor,
            }}
          >
            {t(text)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={cancel}
    >
      <View style={GlobalStyles.centeredView}>
        <View style={GlobalStyles.touchableBackground} />
        <View
          style={[
            styles.modalView,
            {
              position: "absolute",
              maxHeight: "95%",
              //   minHeight: screenSize != "large" ? 200 : 500,
              paddingHorizontal: screenSize === "small" ? 8 : 16,
              paddingVertical: screenSize === "small" ? 16 : 24,
              width: screenSize === "small" ? "90%" : 400,
            },
          ]}
          onStartShouldSetResponder={() => false}
        >
          {/* <View style={{ alignItems: "flex-end" }}>
            <TouchableOpacity onPress={() => onClose()}>
              <Feather
                name="x"
                size={24}
                color={Colors.grayColor}
                style={{
                  paddingHorizontal: 4,
                  paddingTop: 4,
                }}
              />
            </TouchableOpacity>
          </View> */}

          <Text style={Fonts.bold18Centered}>{t(text)}</Text>
          <TextInput
            style={[
              GlobalStyles.textInputStyle,
              {
                borderRadius: 10,
                borderColor: isNameHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
              },
            ]}
            placeholder={t("newFood-string")}
            placeholderTextColor={Colors.grayColor}
            value={name}
            onChangeText={setName}
            maxLength={40}
            onMouseEnter={() => !isMobile && setIsNameHovered(true)}
            onMouseLeave={() => setIsNameHovered(false)}
          />

          {/* <View
            style={[
              GlobalStyles.HStack,
              {
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: 8,
                width: "100%",
              },
            ]}
          >
            <Text style={[Fonts.medium14, {}]}>{t("quantityDots-string")}</Text>
            <View
              style={[
                styles.textInputStyle,
                {
                  borderColor: isQuantityHovered
                    ? "rgba(0, 0, 0, 0.5)"
                    : Colors.borderColor,
                },
              ]}
              onMouseEnter={() => !isMobile && setIsQuantityHovered(true)}
              onMouseLeave={() => setIsQuantityHovered(false)}
            >
              <TextInput
                value={quantity !== null ? quantity.toString() : ""}
                onChangeText={handleChangeQuantity}
                inputMode="numeric"
                placeholder={"100"}
                placeholderTextColor={Colors.grayColor}
                style={{
                  outlineStyle: "none",
                  height: 40,
                  borderRadius: screenSize === "small" ? 8 : 10,
                  color: "black",
                  width: "100%",
                }}
                maxLength={6}
              />

              <Text>g</Text>
            </View>
          </View> */}

          {/* <View
            style={{
              width: "100%",
              height: 0.1,
              backgroundColor: Colors.borderColor,
              marginTop: 8,
            }}
          /> */}

          <View
            style={[
              GlobalStyles.HStack,
              {
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: 8,
                width: "100%",
              },
            ]}
          >
            <Text style={[Fonts.medium14, {}]}>{t("caloriesDots-string")}</Text>
            <View
              style={[
                styles.textInputStyle,
                {
                  borderColor: isCaloriesHovered
                    ? "rgba(0, 0, 0, 0.5)"
                    : Colors.borderColor,
                },
              ]}
              onMouseEnter={() => !isMobile && setIsCaloriesHovered(true)}
              onMouseLeave={() => setIsCaloriesHovered(false)}
            >
              <TextInput
                value={caloriesString}
                onChangeText={handleChangeCalories}
                inputMode="numeric"
                placeholder={"0"}
                placeholderTextColor={Colors.grayColor}
                style={{
                  outlineStyle: "none",
                  height: 40,
                  borderRadius: screenSize === "small" ? 8 : 10,
                  color: "black",
                  width: "100%",
                }}
                maxLength={6}
              />

              <Text>g</Text>
            </View>
          </View>

          <View
            style={[
              GlobalStyles.HStack,
              {
                alignItems: "center",
                // justifyContent: "space-between",
                marginTop: 8,
                width: "100%",
              },
            ]}
          >
            <View
              style={{
                width: 12,
                height: 12,
                borderRadius: 50,
                backgroundColor: Colors.carbsColor,
                marginRight: 8,
              }}
            />
            <Text style={[Fonts.medium14, {}]}>
              {t("carbohydratesDots-string")}
            </Text>
            <View style={{ flex: 1 }} />
            <View
              style={[
                styles.textInputStyle,
                {
                  borderColor: isCarbsHovered
                    ? "rgba(0, 0, 0, 0.5)"
                    : Colors.borderColor,
                },
              ]}
              onMouseEnter={() => !isMobile && setIsCarbsHovered(true)}
              onMouseLeave={() => setIsCarbsHovered(false)}
            >
              <TextInput
                value={carbsString}
                onChangeText={handleChangeCarbs}
                inputMode="numeric"
                placeholder={"0"}
                placeholderTextColor={Colors.grayColor}
                style={{
                  outlineStyle: "none",
                  height: 40,
                  borderRadius: screenSize === "small" ? 8 : 10,
                  color: "black",
                  width: "100%",
                }}
                maxLength={6}
              />

              <Text>g</Text>
            </View>
          </View>

          <View
            style={[
              GlobalStyles.HStack,
              {
                alignItems: "center",
                // justifyContent: "space-between",
                marginTop: 8,
                width: "100%",
              },
            ]}
          >
            <View
              style={{
                width: 12,
                height: 12,
                borderRadius: 50,
                backgroundColor: Colors.proteinColor,
                marginRight: 8,
              }}
            />
            <Text style={[Fonts.medium14, {}]}>{t("proteinDots-string")}</Text>
            <View style={{ flex: 1 }} />
            <View
              style={[
                styles.textInputStyle,
                {
                  borderColor: isProteinHovered
                    ? "rgba(0, 0, 0, 0.5)"
                    : Colors.borderColor,
                },
              ]}
              onMouseEnter={() => !isMobile && setIsProteinHovered(true)}
              onMouseLeave={() => setIsProteinHovered(false)}
            >
              <TextInput
                value={proteinString}
                onChangeText={handleChangeProtein}
                inputMode="numeric"
                placeholder={"0"}
                placeholderTextColor={Colors.grayColor}
                style={{
                  outlineStyle: "none",
                  height: 40,
                  borderRadius: screenSize === "small" ? 8 : 10,
                  color: "black",
                  width: "100%",
                }}
                maxLength={6}
              />

              <Text>g</Text>
            </View>
          </View>

          <View
            style={[
              GlobalStyles.HStack,
              {
                alignItems: "center",
                // justifyContent: "space-between",
                marginTop: 8,
                width: "100%",
              },
            ]}
          >
            <View
              style={{
                width: 12,
                height: 12,
                borderRadius: 50,
                backgroundColor: Colors.fatsColor,
                marginRight: 8,
              }}
            />
            <Text style={[Fonts.medium14, {}]}>{t("fatsDots-string")}</Text>
            <View style={{ flex: 1 }} />
            <View
              style={[
                styles.textInputStyle,
                {
                  borderColor: isFatsHovered
                    ? "rgba(0, 0, 0, 0.5)"
                    : Colors.borderColor,
                },
              ]}
              onMouseEnter={() => !isMobile && setIsFatsHovered(true)}
              onMouseLeave={() => setIsFatsHovered(false)}
            >
              <TextInput
                value={fatsString}
                onChangeText={handleChangeFats}
                inputMode="numeric"
                placeholder={"0"}
                placeholderTextColor={Colors.grayColor}
                style={{
                  outlineStyle: "none",
                  height: 40,
                  borderRadius: screenSize === "small" ? 8 : 10,
                  color: "black",
                  width: "100%",
                }}
                maxLength={6}
              />

              <Text>g</Text>
            </View>
          </View>

          {/* <View
            style={{
              width: "100%",
              height: 0.1,
              backgroundColor: Colors.borderColor,
              marginTop: 8,
            }}
          /> */}

          {/* <View style={{ flexDirection: "row", gap: 8, marginTop: 8 }}>
            <TextInput
              style={[
                GlobalStyles.textInputStyle,
                {
                  borderRadius: 10,
                  borderColor: isBrandHovered
                    ? "rgba(0, 0, 0, 0.5)"
                    : Colors.borderColor,
                  marginTop: 0,
                },
              ]}
              placeholder={t("foodBrand-string")}
              placeholderTextColor={Colors.grayColor}
              value={brand}
              onChangeText={setBrand}
              maxLength={40}
              onMouseEnter={() => !isMobile && setIsBrandHovered(true)}
              onMouseLeave={() => setIsBrandHovered(false)}
            />
            <TextInput
              style={[
                GlobalStyles.textInputStyle,
                {
                  borderRadius: 10,
                  borderColor: isStoreHovered
                    ? "rgba(0, 0, 0, 0.5)"
                    : Colors.borderColor,
                  marginTop: 0,
                },
              ]}
              placeholder={t("foodStore-string")}
              placeholderTextColor={Colors.grayColor}
              value={store}
              onChangeText={setStore}
              maxLength={40}
              onMouseEnter={() => !isMobile && setIsStoreHovered(true)}
              onMouseLeave={() => setIsStoreHovered(false)}
            />
          </View> */}

          <View
            style={[
              GlobalStyles.HStack,
              {
                justifyContent: "center",
                width: "100%",
                justifyContent: "space-around",
                marginTop: 16,
              },
            ]}
          >
            <Buttons bool={false} />
            <Buttons bool={true} />
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalView: {
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
  textInputStyleOld: {
    width: "40%",
    height: 40,
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    color: Colors.blackColor,
    borderWidth: 0.1,
    padding: 10,
    borderRadius: 10,
    outlineStyle: "none",
  },
  textInputStyle: {
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "row",
    width: "40%",
    height: 40,
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    color: Colors.blackColor,
    borderWidth: 0.1,
    paddingHorizontal: 8,
    borderRadius: 10,
    outlineStyle: "none",
  },
});

export default AddCustomFoodView;
